import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { AccountService } from "../../../home-admin-data/account.service";
import { AccountStatus } from "../../../../login-page/login-page-data/login.types";
import { MissionPartner } from "../../../../../api/sign-up/signup.types";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs";

@Component({
  selector: "mh-publishing-limit",
  templateUrl: "./publishing-limit.component.html",
  styleUrls: ["./publishing-limit.component.less"],
})
export class PublishingLimitComponent implements OnInit, OnChanges {
  @Input() missionPartner?: MissionPartner;
  @Input() missionPartnerId!: string;

  publishingLimit = 0;
  isLoading = false;
  isEditing = false;
  newLimit = 0;

  constructor(
    private accountService: AccountService,
    private notificationService: NzNotificationService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.loadPublishingLimit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["missionPartner"] && this.missionPartner) {
      this.loadPublishingLimit();
    }
  }

  get hasPublisherStatus(): boolean {
    return this.missionPartner?.statuses?.includes(AccountStatus.PUBLISHER) || false;
  }

  private loadPublishingLimit() {
    if (!this.hasPublisherStatus) {
      return;
    }

    this.isLoading = true;
    this.accountService
      .getMissionPartnerPublishingLimit(this.missionPartnerId)
      .pipe(take(1))
      .subscribe({
        next: (limit) => {
          this.publishingLimit = limit;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.notificationService.error("", this.translateService.instant("notification.error"));
        },
      });
  }

  onEditLimit() {
    this.newLimit = this.publishingLimit;
    this.isEditing = true;
  }

  onSaveLimit() {
    if (this.newLimit < 0) {
      this.notificationService.error("", this.translateService.instant("admin.publishing-limit.invalid-value"));
      return;
    }

    this.isLoading = true;
    this.accountService
      .setMissionPartnerPublishingLimit(this.missionPartnerId, this.newLimit)
      .pipe(take(1))
      .subscribe({
        next: (success) => {
          if (success) {
            this.publishingLimit = this.newLimit;
            this.isEditing = false;
            this.notificationService.success(
              "",
              this.translateService.instant("admin.publishing-limit.update-success"),
            );
          } else {
            this.notificationService.error("", this.translateService.instant("notification.error"));
          }
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.notificationService.error("", this.translateService.instant("notification.error"));
        },
      });
  }

  onCancelEdit() {
    this.isEditing = false;
    this.newLimit = this.publishingLimit;
  }
}
